<template>
  <div class="kongkim" v-loading="loading">
    <div class="kongkim-div">
      <div class="kongkim-div-first">
        <div class="kongkim-div-first-addition" @click="additionClick">
          <img
            class="first-addition-img"
            src="../../assets/common/common-add.png"
          />
          <div class="first-addition-title">添加</div>
        </div>
      </div>
      <div class="kongkim-div-second">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>

          <el-table-column prop="name" label="金刚区名称"></el-table-column>
          <el-table-column prop="icon" label="icon">
            <template slot-scope="scope">
              <div class="table-icon">
                <img class="table-icon-img" :src="scope.row.image" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="封面图片">
            <template slot-scope="scope">
              <div class="table-cover">
                <img
                  class="table-cover-img"
                  :src="scope.row.beijing_image"
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div
                class="table-status"
                :style="{ color: scope.row.status == 1 ? '' : '#F759AB' }"
              >
                {{ scope.row.status == 1 ? '展示中' : '隐藏' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="firstclassifiedgoodsSet"
            label="金刚区商品设置"
            width="142"
          >
            <template slot-scope="scope">
              <div class="table-set" @click="commoditySetBtn(scope.row)">
                商品设置
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序">
            <template slot-scope="scope">
              <div class="table-sort" @click="sortBtn(scope.row)">
                <!-- <img
                  class="table-sort-left"
                  :src="
                    scope.row.isIndex == 1
                      ? require('../../assets/marketing/marketing-top.png')
                      : require('../../assets/marketing/marketing-no.png')
                  "
                  alt=""
                /> -->
                <img
                  class="table-sort-left"
                  src="../../assets/marketing/marketing-no.png"
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作">
            <template slot-scope="scope">
              <div class="operation">
                <div class="compile" @click="compileBtn(scope.row)">编辑</div>

                <div class="delete" @click="deteleBtn(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="kongkim-div-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 第一区域 添加弹出框 -->
    <div class="addition">
      <el-dialog
        :visible.sync="additionDialogVisible"
        width="590px"
        style="margin-top: 15vh"
        :show-close="false"
        @close="Addreset"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="div-top-title">金刚区添加</div>
              <img
                class="div-top-close"
                src="../../assets/common/close.png"
                @click="Addreset"
              />
            </div>

            <div class="addition-div-center">
              <div class="addition-div-center-left">
                <div class="center-left-title">金刚区名称</div>
                <div class="center-left-input">
                  <el-input
                    placeholder="请输入内容"
                    v-model="additionName"
                    clearable
                  >
                  </el-input>
                </div>
                <div class="center-left-title">状态</div>
                <div class="center-left-check">
                  <div class="center-left-check-show">
                    <el-radio v-model="additionRadio" label="1">展示</el-radio>
                  </div>
                  <div class="center-left-check-conceal">
                    <el-radio v-model="additionRadio" label="2">隐藏</el-radio>
                  </div>
                </div>
                <div class="center-left-display">
                  <div class="center-left-display-backcolor">
                    <div class="backcolor-title">背景色</div>
                    <div class="backcolor-block">
                      <colorPicker v-model="backcolor" />
                    </div>
                  </div>
                  <div class="center-left-display-fontcolor">
                    <div class="fontcolor-title">字体颜色</div>
                    <div class="fontcolor-block">
                      <colorPicker v-model="fontcolor" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="addition-div-center-right">
                <div class="center-right-icon">
                  <div class="center-right-icon-title">icon</div>
                  <div class="center-right-icon-img">
                    <el-upload
                      class="upload-img"
                      action="https://laravel-api-manager.xmw1688.com/common/upload"
                      list-type="picture-card"
                      :on-success="handleSuccess"
                      :limit="1"
                      :show-file-list="false"
                      ref="upload"
                    >
                      <img
                        v-if="additionIcon != ''"
                        :src="additionIcon"
                        class="avatar"
                      />
                      <img
                        v-else
                        src="../../assets/common/common-uploadings.png"
                        class="avatar"
                      />

                      <img
                        class="detele"
                        v-if="additionIcon != ''"
                        src="../../assets/common/common-detele.png"
                        alt=""
                        @click.stop="masterDetele"
                      />
                    </el-upload>
                  </div>
                </div>
                <div class="center-right-cover">
                  <div class="center-right-icon-title">封面图片</div>
                  <div class="center-right-icon-img">
                    <el-upload
                      class="upload-img"
                      action="https://laravel-api-manager.xmw1688.com/common/upload"
                      list-type="picture-card"
                      :on-success="handleSuccess1"
                      :limit="1"
                      :show-file-list="false"
                      ref="upload1"
                    >
                      <img
                        v-if="additionBack != ''"
                        :src="additionBack"
                        class="avatar"
                      />
                      <img
                        v-else
                        src="../../assets/common/common-uploadings.png"
                        class="avatar"
                      />

                      <img
                        class="detele"
                        v-if="additionBack != ''"
                        src="../../assets/common/common-detele.png"
                        alt=""
                        @click.stop="masterDetele1"
                      />
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>

            <div class="addition-div-button">
              <!-- <div class="addition-div-button-reset" @click="Addreset">
                重置
              </div> -->
              <div class="addition-div-button-confirm" @click="Addconfirm">
                确定
              </div>
            </div>
          </div>
        </span></el-dialog
      >
    </div>

    <!-- 第二区域  删除 -->
    <div class="detele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="cancelDetele"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">请重新确定是否删除？</div>
            <div class="detele-div-text">
              一旦确定后，则删除该一级分类，包括关联的商品也将删除。
            </div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="confirmDetele">
                确定
              </div>
              <div class="detele-div-button-right" @click="cancelDetele">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus'

import {
  getMarketKingList,
  postMarketKingAdd,
  deletefnMarketKing,
  putfnMarketKing,
} from '../../api/marketing'

export default {
  data() {
    return {
      // 第一区域 添加弹出框
      additionDialogVisible: false,
      // 第一区域 添加弹出框 单选
      additionRadio: '1',
      // 第一区域 添加弹出框 金刚区名称
      additionName: '',
      // 第一区域 添加弹出框 id
      additionId: '',
      // 第一区域 添加弹出框 icon
      additionIcon: '',
      // 第一区域 添加弹出框 封面图片
      additionBack: '',
      // 第一区域 添加弹出框 背景颜色
      backcolor: '#d8d8d8',
      // 第一区域 添加弹出框 字体颜色
      fontcolor: '#222222',

      // 第二模块 表格数组数据
      tableData: [],
      // 表格数据总数
      totalNum: 0,

      /* 删除弹出框 */
      deteleDialogVisible: false,
      // 页码
      page: 1,
      // 页数
      limit: 10,
      // 监听用户刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      marketingFunShow: false,
    }
  },
  created() {
    // 金刚区列表
    this.loading = true
    this.getMarketKingClick()

    setTimeout(() => {
   this.marketingFunShow = this.$store.state.pageFunctionShow

    }, 1000);
  },
  methods: {
    // 获取金刚区列表数据
    getMarketKingClick() {
      let params = {
        pageSize: this.limit,
        pageNo: this.page,
      }
      getMarketKingList(params).then((res) => {
        console.log('获取列表数据', res)
        if (res.resultStatus == true) {
          this.tableData = res.resultData.jinList
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },
    // 用户点击添加按钮开启弹出框
    additionClick() {
      if (this.marketingFunShow == false) {
        return
      }
      this.additionDialogVisible = true
    },

    // 用户点击添加弹出框  取消
    Addreset() {
      this.additionId = ''
      this.additionName = ''
      this.additionIcon = ''
      this.additionBack = ''
      this.additionRadio = '1'
      this.backcolor = ''
      this.fontcolor = ''
      this.additionDialogVisible = false
    },
    // 用户点击添加弹出框  确定
    Addconfirm() {
      let params = {
        id: this.additionId, // true
        name: this.additionName, // 金刚区名称
        image: this.additionIcon, // icon
        beijing_image: this.additionBack, // 封面图片
        status: this.additionRadio, // 状态 1展示
        color: this.backcolor == '' ? '#d8d8d8' : this.backcolor, // 背景色
        color1: this.fontcolor == '' ? '#222222' : this.fontcolor, // 畅销新品字体颜色
      }

      console.log('获取params', params)
      postMarketKingAdd(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '添加成功',
            type: 'success',
          })
          this.loading = true
          this.additionDialogVisible = false
          this.getMarketKingClick()
        }
      })
    },

    // 编辑弹出框 开启
    compileBtn(item) {
      if (this.marketingFunShow == false) {
        return
      }

      console.log('点击编辑', item)
      this.additionId = item.id
      this.additionName = item.name
      this.additionIcon = item.image
      this.additionBack = item.beijing_image
      this.additionRadio = item.status + ''
      this.backcolor = item.color
      this.fontcolor = item.color1
      this.additionDialogVisible = true
    },

    // 用户点击跳转对应的页面
    commoditySetBtn(item) {
      if (this.marketingFunShow == false) {
        return
      }

      Bus.$emit('log', 'marketingFirstclassifi', item)
    },
    /* 删除 */
    // 开启删除弹出框
    deteleBtn(item) {
      if (this.marketingFunShow == false) {
        return
      }

      this.additionId = item.id
      this.deteleDialogVisible = true
    },
    // 确定删除框
    confirmDetele() {
      let params = this.additionId

      deletefnMarketKing(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '删除成功！',
            type: 'success',
          })
          this.loading = true
          this.deteleDialogVisible = false
          this.getMarketKingClick()
        }
      })
    },

    // 取消删除弹出框
    cancelDetele() {
      this.additionId = ''
      this.deteleDialogVisible = false
    },

    // icon 点击上传
    // 上传成功
    handleSuccess(file, fileList) {
        this.$refs.upload.clearFiles()
      this.additionIcon = file.resultData
    },
    masterDetele() {
      this.additionIcon = ''
    },

    // 封面图片 点击上传
    // 上传成功
    handleSuccess1(file, fileList) {
        this.$refs.upload1.clearFiles()
      this.additionBack = file.resultData
    },
    masterDetele1() {
      this.additionBack = ''
    },

    // 商品区域 排序
    sortBtn(item) {
      if (this.marketingFunShow == false) {
        return
      }

      console.log(item)
      let params = item.id
      putfnMarketKing(params).then((res) => {
        if (res.resultStatus == true) {
          this.loading = true
          this.$message({
            message: '置顶成功',
            type: 'success',
          })
          this.loading = true
          this.getMarketKingClick()
        }
      })
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      this.getMarketKingClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      console.log(`当前页: ${val}`)
      this.getMarketKingClick()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.kongkim {
  background: #ffffff;
  height: 100%;
  .kongkim-div {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    box-sizing: border-box;
    .kongkim-div-first {
      height: 80px;
      display: flex;
      align-items: center;

      .kongkim-div-first-addition {
        width: 82px;
        height: 36px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .first-addition-img {
          width: 13px;
          height: 13px;
        }

        .first-addition-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }

    .kongkim-div-second {
      /deep/ .el-table .el-table__cell {
        padding: 13px 0;
        vertical-align: top;
      }
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-icon {
        .table-icon-img {
          width: 68px;
          height: 68px;
          border-radius: 5px;
        }
      }
      .table-cover {
        width: 136px;
        height: 68px;
        .table-cover-img {
          width: 136px;
          height: 68px;
          background: #e9edf4;
          border-radius: 5px;
        }
      }

      .table-status {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
      }

      .table-set {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
      }

      .table-sort {
        display: flex;

        .table-sort-left,
        .table-sort-right {
          width: 26px;
          height: 26px;
        }

        .table-sort-right {
          margin-left: 4px;
        }
      }

      .operation {
        display: flex;

        .compile,
        .delete {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        .delete {
          margin-left: 24px;
        }
      }
    }

    .kongkim-div-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  /* 添加编辑弹出框 */
  .addition {
    /deep/ .el-dialog {
      height: 350px;
    }
    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    .addition-div {
      .addition-div-top {
        display: flex;
        height: 56px;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #e9edf4;

        .div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
        }

        .div-top-close {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }

      .addition-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        display: flex;
        margin-top: 20px;
        .addition-div-center-left {
          .center-left-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .center-left-input {
            width: 254px;
            height: 32px;
            margin-top: 4px;
            margin-bottom: 16px;

            /deep/ .el-input {
              width: 100%;
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }
          }

          .center-left-check {
            display: flex;
            margin-top: 7px;
            .center-left-check-show,
            .center-left-check-conceal {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #222222;
            }

            .center-left-check-conceal {
              margin-left: 52px;
            }
          }

          .center-left-display {
            display: flex;
            margin-top: 24px;

            .center-left-display-backcolor {
              .backcolor-title {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .backcolor-block {
                width: 18px;
                height: 18px;
                border-radius: 2px;
                cursor: pointer;
                margin-top: 4px;
              }
            }

            .center-left-display-fontcolor {
              margin-left: 68px;

              .fontcolor-title {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .fontcolor-block {
                width: 18px;
                height: 18px;
                border-radius: 2px;
                cursor: pointer;
                margin-top: 4px;
              }
            }
          }
        }

        .addition-div-center-right {
          margin-left: 30px;
          display: flex;

          .center-right-icon,
          .center-right-cover {
            .center-right-icon-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .center-right-icon-img {
              width: 100px;
              height: 100px;
              cursor: pointer;
              position: relative;

              .upload-img {
                width: 100px;
                height: 100px;
                position: relative;

                /deep/ .el-upload--picture-card {
                  width: 100px;
                  height: 100px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border: 1px solid rgba(255, 255, 255, 0);
                }

                /deep/ .el-upload--picture-card:hover {
                  border-color: rgba(255, 255, 255, 0);
                }

                /deep/ .el-upload-list--picture-card .el-upload-list__item {
                  width: 100px;
                  height: 100px;
                  margin: 0;
                }
                .avatar {
                  width: 100px;
                  height: 100px;
                }

                .detele {
                  position: absolute;
                  top: -10px;
                  right: -10px;
                  width: 20px;
                  height: 20px;
                }
              }
            }
          }

          .center-right-cover {
            margin-left: 30px;
          }
        }
      }

      .addition-div-button {
        display: flex;
        height: 52px;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 35px;
        border-top: 1px solid #e9edf4;

        .addition-div-button-reset,
        .addition-div-button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          cursor: pointer;
        }

        .addition-div-button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }

  /* 右侧删除弹出框 */
  .detele {
    /deep/ .el-dialog {
      height: 231px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      box-sizing: border-box;
    }

    .detele-div {
      width: 100%;
      text-align: center;
      padding-top: 25px;
      .detele-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .detele-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }

      .detele-div-text {
        width: 319px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;
      }

      .detele-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .detele-div-button-left,
        .detele-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .detele-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
